<template>
  <div class="clean page-wrapper">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'CleanTemplate',
    components: {
    },
    data () {
      return {

      }
    }
  }
</script>

<style scoped>

</style>
